
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import {swalConfirm, swalError, swalSuccess, swalWarning} from '@/plugins/swal';

@Component
export default class Dashboard extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  sheet = false;
  listStatus = [];
  show = true;
  dialog = false;
  tab = null;
  title = '-';
  location = '-';
  aplicationDetailHeader = [];
  aplicationDetail = [];
  items = [this.$t('reviewed'), this.$t('selection'), this.$t('approved')];
  text =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.';
  async mounted() {
    this.facthData();
  }
  async facthData() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('jobs/allStatusApply');
      this.finishLoading('detail');
      if (data?.status.length > 0) {
        this.title = data?.title;
        this.location = data?.city;
        this.listStatus = data?.status;
      } else {
        swalWarning.fire({
          title: 'Warning!',
          text: 'Belum ada status, mohon check secara berkala.',
        });
        this.$router.push('/');
      }
    } catch (e) {
      this.catchError(e);
    }
  }
  async showDialog(item: string | number) {
    try {
      const {data} = await this.$store.dispatch('jobs/detailStatusApply', item);
      this.aplicationDetail = data;
      this.dialog = true;
    } catch (e) {
      this.catchError(e);
    }
  }
  async onChange(id: number, item: number | string) {
    const {value: confirmed} = await swalConfirm.fire({
      text: `Apakah anda yakin ${
        item === 1 ? 'akan hadir' : 'tidak hadir'
      } pada undangan ini?`,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak',
    });
    if (confirmed) {
      try {
        const {data} = await this.$store.dispatch('jobs/changeStatusApplies', {
          id,
          payload: item,
        });
        if (data) {
          swalSuccess.fire({
            title: 'Success!',
            text: data.message,
          });
          this.finishLoading('saving');
        }
        this.aplicationDetail = data;
        this.facthData();
        this.dialog = false;
      } catch (e) {
        swalError.fire({
          title: 'Failed!',
          text:
            e.response?.error?.message ||
            'Sebuah kesalahan yang tidak diduga telah terjadi.',
        });
      }
    }
  }
}
